import { api, APIResponse } from '@/store/api';
import type { GetInmopublicAccountsParams, GetInmopublicAccountsResponse } from '@/types/inmopublic-accounts.types';

export type CreateInmopublicAccountRequest = {
  name: string;
  logo: string;
  municipality: string;
  status?: 'ACTIVE' | 'INACTIVE';
  primaryDomain?: string;
};

export type CreateInmopublicAccountResponse = {
  account: {
    id: string;
    name: string;
    logo: string;
    municipality: string;
    status: 'ACTIVE' | 'INACTIVE';
    primaryDomain?: string;
  };
};

export const inmopublicAccountsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getInmopublicAccounts: builder.query<GetInmopublicAccountsResponse, GetInmopublicAccountsParams>({
      query: (params = {}) => {
        const searchParams = new URLSearchParams();
        if (params.page) searchParams.append('page', params.page.toString());
        if (params.limit) searchParams.append('limit', params.limit.toString());
        if (params.text) searchParams.append('text', params.text);
        return {
          url: `admin-inmopublic/accounts?${searchParams.toString()}`,
          method: 'GET',
        };
      },
      transformResponse: (response: APIResponse<GetInmopublicAccountsResponse>) => response.data,
      providesTags: ['InmopublicAccounts'],
    }),

    createInmopublicAccount: builder.mutation<CreateInmopublicAccountResponse, CreateInmopublicAccountRequest>({
      query: (accountData) => ({
        url: 'admin-inmopublic/accounts',
        method: 'POST',
        body: accountData,
      }),
      transformResponse: (response: APIResponse<CreateInmopublicAccountResponse>) => response.data,
      invalidatesTags: ['InmopublicAccounts'],
    }),
  }),
});

export const { useGetInmopublicAccountsQuery, useCreateInmopublicAccountMutation } = inmopublicAccountsApi;
